import DisplayPicksHeader from './DisplayPicksHeader';
export default DisplayPicksHeader;
